import Cookies from "js-cookie";

const getCSRFToken: () => string | null | undefined = () =>
  Cookies.get("csrf_token");

export default getCSRFToken;
